module.exports = __webpack_public_path__ + "static/media/carl987-065-copy.2ed0b0b6.jpg";